import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-[90vh] flex items-center justify-center bg-background-50 overflow-hidden pt-[72px]">
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-[12%] h-[65%] rounded-3xl overflow-hidden z-0 hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20woman%20in%20cream%20linen%20blazer%20walking%20on%20a%20sunlit%20cobblestone%20street%20in%20a%20European%20old%20town%2C%20candid%20lifestyle%20fashion%20shot%2C%20back%20view%20with%20flowing%20movement%2C%20warm%20golden%20hour%20light%2C%20soft%20bokeh%20background%20with%20historic%20architecture%2C%20editorial%20fashion%20photography%2C%20sophisticated%20neutral%20tones%2C%20aspirational%20travel%20mood%2C%20high%20fashion%20street%20style%2C%20dreamy%20atmosphere&width=600&height=900&seq=hero-left-v3&orientation=portrait"
          alt="Fashion lifestyle photography"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-[12%] h-[65%] rounded-3xl overflow-hidden z-0 hidden lg:block">
        <img
          src="https://readdy.ai/api/search-image?query=Close%20up%20detail%20of%20premium%20textile%20textures%20including%20soft%20cashmere%20knit%2C%20raw%20silk%2C%20and%20organic%20linen%20swatches%20arranged%20in%20an%20artistic%20overlapping%20composition%2C%20warm%20natural%20lighting%20from%20a%20nearby%20window%2C%20tactile%20sensory%20photography%2C%20soft%20cream%20sand%20and%20ecru%20tones%2C%20artisan%20craftsmanship%20aesthetic%2C%20abstract%20fashion%20detail%2C%20rich%20textural%20depth&width=600&height=900&seq=hero-right-v3&orientation=portrait"
          alt="Premium textile textures photography"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="relative z-10 w-full max-w-[800px] mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-100 border border-background-200/70 mb-8">
          <i className="ri-database-2-line text-sm text-primary-600"></i>
          <span className="text-xs text-foreground-600 font-medium tracking-wide">Independent Research Hub 2026</span>
        </div>

        <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-foreground-950 leading-tight mb-6">
          Hipobuy Spreadsheet
          <br />
          <span className="text-primary-600">The Complete Shopping Guide</span>
        </h1>

        <p className="text-base md:text-lg text-foreground-600 font-light max-w-[560px] mx-auto mb-10 leading-relaxed">
          Discover organized product spreadsheets, buying guides, comparison tools, QC information,
          and expert resources to make smarter purchasing decisions faster.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/hipobuy-spreadsheet-guide"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors duration-200"
          >
            Explore Spreadsheet Guide
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="w-full sm:w-auto px-8 py-3.5 rounded-full border-2 border-primary-500 text-primary-700 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-50 transition-colors duration-200"
          >
            Visit Main Platform
            <i className="ri-external-link-line ml-2"></i>
          </a>
        </div>

        <p className="text-xs text-foreground-400 mt-3">External link opens kaspreadsheet.com in a new tab</p>

        <div className="flex flex-wrap items-center justify-center gap-5 mt-12 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-600 text-sm"></i>
            Updated Research Database
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-600 text-sm"></i>
            Beginner Friendly Guides
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-600 text-sm"></i>
            Product Comparison Resources
          </span>
          <span className="flex items-center gap-1.5">
            <i className="ri-check-line text-accent-600 text-sm"></i>
            Safety First Approach
          </span>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-background-100 to-transparent z-10"></div>
    </section>
  );
}